import { configs } from '@constants/configs/configs';
import axios from 'axios';

const { routes } = configs;

export const axiosApi = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': window.csrf_token,
        'X-UID': window.UID,
        'X-EMAIL': 'window.EMAIL',
        'csrftoken': window.csrf_token
    }
});

// Add a response interceptor
axiosApi.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response && error.response.status === 401 || error.response.status === 408)  {
            // Handle 401 error (Unauthorized)
            window.location.href = routes.FALLBACK;
        }
        return Promise.reject(error);
    },
);

